<template>
    <div class="row" v-if="this.consum">
        <div v-if="showElectric" class="col-12 mb-2">
            <h3 class="mb-4">{{ $t('pds.environment.power_consumption_wltp') }}</h3>
            <div class="row">
                <PdsDataEntry :title="$t('pds.environment.city')" :value="this.consum.wltp_power_consumption_city"> {{$t('pds.environment.kwh_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.periphery')" :value="this.consum.wltp_power_consumption_urban"> {{$t('pds.environment.kwh_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.highway')" :value="this.consum.wltp_power_consumption_rural"> {{$t('pds.environment.kwh_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.motorway')" :value="this.consum.wltp_power_consumption_highway"> {{$t('pds.environment.kwh_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.combined')" :value="this.consum.wltp_power_consumption_combined"> {{$t('pds.environment.kwh_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.range')" :value="this.consum.wltp_em_range"> km</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.co2_emissions_combined')" :value="this.consum.wltp_co2_emissions"> {{$t('pds.environment.g_km')}}</PdsDataEntry>
            </div>
        </div>

        <div v-if="showHybrid" class="col-12">
            <h3 class="mb-4">{{ $t('pds.environment.consumption_hybrid_wltp') }}</h3>
            <div class="row">
                <PdsDataEntry :title="$t('pds.environment.combined_power_consumption')" :value="this.consum.wltp_power_consumption_weighted"> {{$t('pds.environment.kwh_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.fuel_consumption_weighted_combined')" :value="this.consum.wltp_fuel_consumption_weighted"> {{$t('pds.environment.l_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.fuel_consumption_discharged_bat')" :value="this.consum.wltp_fuel_consumption_depleted_battery"> {{$t('pds.environment.l_100km')}}</PdsDataEntry>
            </div>
            <div class="row">
                <PdsDataEntry :title="$t('pds.environment.co2_emissions_wt_comb')" :value="this.consum.wltp_co2_emissions_weighted"> {{$t('pds.environment.g_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.co2_discharged_bat')" :value="this.consum.wltp_co2_emissions_depleted_battery"> {{$t('pds.environment.g_100km')}}</PdsDataEntry>
            </div>
        </div>

        <div v-if="showPetrol" class="col-12">
            <h3 class="mb-4">{{ $t('pds.environment.consumption_patrol_wltp') }}</h3>
            <div class="row">
                <PdsDataEntry :title="$t('pds.environment.city')" :value="this.consum.wltp_consumption_city"> {{$t('pds.environment.l_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.periphery')" :value="this.consum.wltp_consumption_urban"> {{$t('pds.environment.l_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.highway')" :value="this.consum.wltp_consumption_rural"> {{$t('pds.environment.l_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.motorway')" :value="this.consum.wltp_consumption_highway"> {{$t('pds.environment.l_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.combined')" :value="this.consum.wltp_consumption_combined"> {{$t('pds.environment.l_100km')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.co2_emissions_combined')" :value="this.consum.wltp_co2_emissions"> {{$t('pds.environment.g_km')}}</PdsDataEntry>
            </div>
        </div>

        <div class="col-12">
            <h3 class="mb-4">{{ $t('pds.environment.annual_costs') }}</h3>
            <div class="row" v-if="showKm">
                <PdsDataEntry :title="$t('pds.environment.co2_lowest')" :value="this.consum.cost_co2_low_15000_km"> {{$t('pds.environment.euro')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.co2_average')" :value="this.consum.cost_co2_avg_15000_km"> {{$t('pds.environment.euro')}}</PdsDataEntry>
                <PdsDataEntry :title="$t('pds.environment.co2_highest')" :value="this.consum.cost_co2_high_15000_km"> {{$t('pds.environment.euro')}}</PdsDataEntry>
            </div>

            <div class="row" v-if="this.consum.energy_cost_15000_km">
                <PdsDataEntry :title="$t('pds.environment.energie')" :value="this.consum.energy_cost_15000_km"> {{$t('pds.environment.euro')}}</PdsDataEntry>
            </div>

            <div class="row">
                <PdsDataEntry :title="$t('pds.environment.vehicle_tax')" :value="this.consum.vehicle_tax_annual"> {{$t('pds.environment.euro')}}</PdsDataEntry>
            </div>
        </div>
        
        <div class="col-12 mb-4">{{$t('pds.environment.all_costs_except')}}</div>

        <div class="col-12 text-muted mb-4">
            <p v-html="getInfoText"></p>
            <span><small>{{$t('pds.environment.hint')}}</small></span>
        </div>

        <div v-if="showCo2Class" class="col-12">
            <h3 class="mb-4">{{ $t('pds.environment.co2class') }}</h3>
            <div>
                {{ $t('pds.environment.co2class_subtitle') }}
            </div>

            <table>
                <tr v-if="this.consum.wltp_co2_class_weighted_combined || this.consum.wltp_co2_class_depleted_battery && !this.consum.wltp_co2_class" class="text-center" style="font-size:10pt">
                    <td></td>
                    <td v-if="this.consum.wltp_co2_class_weighted_combined" class="pr-2">
                        {{ $t('pds.environment.weighted_comined') }}
                    </td>    
                    <td v-if="this.consum.wltp_co2_class_depleted_battery" class="pl-2" style="border-left: 2px solid grey;">
                        {{ $t('pds.environment.discharged_bat') }}
                    </td>
                </tr>

                <tr>
                    <td class="mr-2">
                        <img :src="this.$root.googleApi.storage('effizienz/wltp-co2-klassen-links.png')" alt="CO2 Klasse Tabelle" style="max-height: 300px;"/>
                    </td>
                    <td v-if="this.consum.wltp_co2_class && (!this.consum.wltp_co2_class_weighted_combined || !this.consum.wltp_co2_class_depleted_battery)">
                        <img :src="this.$root.googleApi.storage('effizienz/wltp-co2-klasse-' + this.consum.wltp_co2_class.toLowerCase() + '.png')" :alt="$t('pds.environment.co2class_subtitle')" style="max-height: 300px;"/>

                    </td>
                    <td v-if="this.consum.wltp_co2_class_weighted_combined" class="text-center pr-2">
                        <img :src="this.$root.googleApi.storage('effizienz/wltp-co2-klasse-' + this.consum.wltp_co2_class_weighted_combined.toLowerCase() + '.png')" :alt="$t('pds.environment.weighted_comined')" style="max-height: 300px;"/>

                    </td>
                    <td v-if="this.consum.wltp_co2_class_depleted_battery" class="text-center" style="border-left: 2px solid grey;">
                        <img :src="this.$root.googleApi.storage('effizienz/wltp-co2-klasse-' + this.consum.wltp_co2_class_depleted_battery.toLowerCase() + '.png')" :alt="$t('pds.environment.discharged_bat')" style="max-height: 300px;"/>

                    </td>
                </tr>
            </table>
        </div>
    </div>
    
    <div v-else>
        <span>{{$t('pds.details.not_specified')}}</span>
    </div>
</template>

<script>
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import PdsDataEntry from "../atoms/PdsDataEntry.vue";

export default {
    name: 'EnvironmentConsumptionBox',
    components: {
        DataEntryColumn, PdsDataEntry
    },

    props: {
        entry: null,
    },

    data() {
        return {
            consum: {},
        }
    },

    computed: {
        getAddress(){
            return this.entry ? `${this.entry.subsidiary.contact.title}, ${this.entry.subsidiary.contact.address.street}, ${this.entry.subsidiary.contact.address.postal_code} ${this.entry.subsidiary.contact.address.city}` : ''
        },
        getInfoText(){
            return this.entry ? `${this.$t('pds.environment.co2_hint_1')} ${this.getAddress} ${this.$t('pds.environment.co2_hint_2')}` : ''
        },
        showElectric() {
            if (this.consum.wltp_power_consumption_city > 0 || this.consum.wltp_power_consumption_urban > 0 ||  this.consum.wltp_power_consumption_rural > 0 ||  this.consum.wltp_power_consumption_highway > 0 ||  this.consum.wltp_power_consumption_combined > 0 ||  this.consum.wltp_em_range > 0) {
                return true
            }
            return false
        },
        showHybrid(){
            if(this.consum.wltp_co2_emissions_weighted > 0 || this.consum.wltp_power_consumption_weighted > 0 || this.consum.wltp_fuel_consumption_weighted > 0 || this.consum.wltp_co2_emissions_depleted_battery > 0 || this.consum.wltp_fuel_consumption_depleted_battery > 0) {
                return true
            }
            return false
        },
        showPetrol(){
            if(this.consum.wltp_consumption_city > 0 || this.consum.wltp_consumption_urban > 0 || this.consum.wltp_consumption_rural > 0 || this.consum.wltp_consumption_highway > 0 || this.consum.wltp_consumption_combined > 0) {
                return true
            }
            return false
        },
        showKm(){
            if(this.consum.cost_co2_low_15000_km > 0 || this.consum.cost_co2_avg_15000_km > 0 || this.consum.cost_co2_high_15000_km > 0) {
                return true
            }
            return false
        },
        showCo2Class(){
            if(this.consum.wltp_co2_class != null || this.consum.wltp_co2_class_weighted_combined != null || this.consum.wltp_co2_class_depleted_battery != null) {
                return true
            }
            return false
        }
    },
    mounted() {
        if(this.entry.consumptions != undefined){
            this.consum = this.entry.consumptions
        } else {
            this.consum  = false
        }
    }
}
</script>